import React from 'react';

function ContainersIcon() {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="18"
      height="18"
      viewBox="0 0 18 18"
    >
      <g fill="none" fillRule="evenodd" stroke="none" strokeWidth="1">
        <g fill="#FFF" fillRule="nonzero" transform="translate(-172 -1346)">
          <g transform="translate(136 1175)">
            <path d="M52.615 171c.765 0 1.385.62 1.385 1.385v15.23c0 .765-.62 1.385-1.385 1.385h-15.23c-.765 0-1.385-.62-1.385-1.385v-15.23c0-.765.62-1.385 1.385-1.385h15.23zm-4.153 13.846h-9.693a1.385 1.385 0 00-.161 2.76l.161.01h9.693a1.385 1.385 0 00.161-2.76l-.161-.01zm2.769-12.461c-.71 0-1.296.534-1.376 1.223l-.009.161v4.154a1.385 1.385 0 002.76.162l.01-.162v-4.154c0-.764-.62-1.384-1.385-1.384z" />
          </g>
        </g>
      </g>
    </svg>
  );
}

export default ContainersIcon;



// WEBPACK FOOTER //
// ./src/components/modules/Examples/ContainersIcon.js